import { createReducer, on } from '@ngrx/store';
import { deviceActions } from '../actions/device.actions';

export interface DeviceState {
    locked: boolean;
}

export const initialState: DeviceState = {
    locked: false,
};

export const deviceReducer = createReducer(
    initialState,
    on(deviceActions.lock, (): DeviceState => ({ locked: true })),
    // Only `unlock` drops the gate. `switchUser` keeps it up: the bridge holds the overlay until
    // the new user's session + profile have loaded, then dispatches `unlock`.
    on(deviceActions.unlock, (): DeviceState => ({ ...initialState })),
);
